import { render } from "./vphoneloginempower.vue?vue&type=template&id=8844f6cc&scoped=true"
import script from "./vphoneloginempower.vue?vue&type=script&lang=js"
export * from "./vphoneloginempower.vue?vue&type=script&lang=js"

import "./vphoneloginempower.vue?vue&type=style&index=0&id=8844f6cc&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8844f6cc"]])

export default __exports__